export enum UserStatus {
  /** User is logged in */
  LOGGED_IN = 'logged in',

  /** User is logged out */
  LOGGED_OUT = 'logged out',
}
